<template>
    <div class="liveEventContent">
        <div class="container">
            <div class="liveEvent">
            <div class="row">
                <div class="col-md-12">
                    <div class="main-content">
                        <h3 class="heading">Welcome to Corporate Live Events</h3>
                    </div>
                </div></div>
                <div class="row" v-if="getCorpStreamingURL">
                    <div class="col-md-12">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe title="TONE video player" class="embed-responsive-item" :src="getCorpStreamingURL"></iframe>
                    </div>
                </div>
                <!--<div class="col-md-12" v-if="getAmcStreamingURL">-->
                    <!--<iframe :src="getAmcStreamingURL" width="100%" height="600px" style="max-height: 51vw;" frameborder="0" scrolling="auto" allowfullscreen ></iframe>-->
                <!--</div>-->
            </div>
                <br>
                <br>
        </div>
    </div>
    </div>
</template>

<script>
    import spinner from '@/accessibility/Spinner'
    import alert from '@/accessibility/Alert'
    import input from '@/accessibility/Input'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'amcliveevent',
        metaInfo () {
            return {
                title: 'TONE | Welcome to Private Live stream!',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Welcome to Private Live stream'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Welcome to Private Live stream'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                contactForm: {
                    emailAddress: '',
                    phoneNumber: '',
                    reason: '',
                    comments: ''
                },
                spinner: false
            }
        },
        computed: {
            ...mapGetters([
                'user', 'error', 'getCorpStreamingURL'
            ])
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    p strong {
        font-weight: 900;
        color: #000;
    }

    .text-left p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// CorporateLiveEvent.vue?17d53dcc